import { CookieHelper } from 'utils/helper/cookie-helper';

/**
 * If window.ga is ready, get ga client id
 */
const createGaClientIdStorageEntry = () => {
  if (!sessionStorage.getItem('gaClientId') && window.ga && window.ga.create) {
    sessionStorage.setItem('gaClientId', window.ga.getAll()[0].get('clientId'));
  }
};

/**
 * Creating originalSource and originalReferer Cookies for UTMs processing
 */
const createUtmsCookies = () => {
  if (
    !sessionStorage.getItem('originalReferer') &&
    !!document.referrer &&
    document.referrer !== null &&
    document.referrer !== undefined
  ) {
    sessionStorage.setItem(
      'originalReferer',
      document.referrer
        .replace(/https:\/\//g, '')
        .replace(/http:\/\//g, '')
        .split('/')[0],
    );
    CookieHelper.createWithExpiration('originalReferer', sessionStorage.getItem('originalReferer'), 1);
  }

  if (!sessionStorage.getItem('originalSource') && document.location.href) {
    const originalSource = document.location.href;
    sessionStorage.setItem(
      'originalSource',
      originalSource
        .replace(/https:\/\//g, '')
        .replace(/http:\/\//g, '')
        .split('/')[0] + document.location.search,
    );
    CookieHelper.createWithExpiration('originalSource', sessionStorage.getItem('originalSource'), 2);
  }
};

const SessionDataHelper = {
  createUtmsCookies,
  createGaClientIdStorageEntry,
};

export { SessionDataHelper };
